(function () {
    'use strict';
    var controllerId = 'tAttachAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'tSource', 'tSourceId', tAttachAdd]);

    function tAttachAdd($scope, datacontext, sectionMenu, $uibModalInstance, tSource, tSourceId) {
        $scope.tAttach = {};
        $scope.tSource = tSource;
        $scope.tAttach.MinValue = 1;
        
        if (tSourceId) {
            $scope.tSourceId = tSourceId;
            $scope.tAttach.TSourceId = tSourceId;
            $scope.tAttach.TSource = $scope.tSource[0].Name;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.tAttach)
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.tAttach_add(item).then(function (data) {                
                if (!data) return null;
                if (data== "400") return null;

                return data;
            });
        }

        $scope.TitleChanged = function () {        	
        	$scope.bTitleChanged = true;
        	return false;
        }

        
    }
})();